const isDevMode = process.env.NODE_ENV === 'development';  
const HOST = isDevMode ? 'http://localhost:3001' : 'https://www.calii.com';
const API_PATH = 'web_api';
const prefix = `${HOST}/${API_PATH}`;
const API_PATH_LEGACY = 'api/v1';
const prefixLegacy = `${HOST}/${API_PATH_LEGACY}`;

export default {
  PRODUCT_SEARCH: `${prefixLegacy}/search`,
  PRODUCT_DETAILS: `${prefixLegacy}/catalog_items`,
  COLLECTIONS: `${prefix}/collections`,
  FEES_CONSTANTS: `${prefixLegacy}/fees_constants`,
  AUTH_LOGIN: `${prefixLegacy}/login`,
  AUTH_REGISTER: `${prefixLegacy}/users`,
  AUTH_LOGOUT: `${prefixLegacy}/logout`,
  AUTH_ME: `${prefixLegacy}/me`,
  AUTH_REFRESH: `${prefix}/auth_refresh`,
  USER_ADDRESSES: `${prefixLegacy}/shipping_infos`,
  CARDS: `${prefixLegacy}/credit_cards`,
  DELIVERY_WINDOWS: `${prefixLegacy}/delivery_windows`,
  REFRESH_CART: `${prefix}/refresh_cart`,
  ADD_COUPON: `${prefix}/add_coupon`,
  COUPON_UPDATES: `${prefix}/coupon_updates`,
  SUGGESTED_ITEMS: `${prefixLegacy}/suggested_items`,
  ORDERS: `${prefixLegacy}/orders`,
  CALII_PLUS_MEMBERSHIPS: `${prefixLegacy}/calii_plus_memberships`,
  PASSWORD_RESET_REQUESTS: `${prefixLegacy}/password_reset_requests`,
  TRACKED_ACTIONS: `${prefix}/web_tracked_actions`,
};
